export default __webpack_public_path__ + "static/media/search.42ebca24.svg";